import React from 'react';

const LandingPagesIcon = ({
  color = '#8774FF',
  size = 12,
}) => {
  return (
    <svg
      width={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M20.25 0H2.25C1.0125 0 0.01125 1.0125 0.01125 2.25L0 15.75C0 16.9875 1.0125 18 2.25 18H20.25C21.4875 18 22.5 16.9875 22.5 15.75V2.25C22.5 1.0125 21.4875 0 20.25 0ZM14.625 15.75H2.25V11.25H14.625V15.75ZM14.625 10.125H2.25V5.625H14.625V10.125ZM20.25 15.75H15.75V5.625H20.25V15.75Z" fill={color} />
    </svg>
  );
};

export default LandingPagesIcon;
